module.exports = __webpack_public_path__ + "assets/img/34_775_big.faf115a7.jpg";